export function TravelAdventureDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Travel & Adventure Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Event Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Type of Event <span className="text-red-500">*</span>
            </label>
            <select className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200">
              <option value="">Select event type</option>
              <option value="first_international">First International Trip</option>
              <option value="extended_travel">Extended Travel</option>
              <option value="adventure">Adventure Experience</option>
              <option value="cultural">Cultural Immersion</option>
              <option value="milestone">Milestone Journey</option>
            </select>
          </div>

          {/* Destination */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Destination <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter destination"
            />
          </div>

          {/* Start Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Start Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* End Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              End Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Purpose */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Purpose of Travel
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Describe the purpose and goals of this journey"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 